import { loadScript } from '../../../utils';

const GOOGLE_MAPS_SCRIPT_ID = 'google-maps';
const GSI_SCRIPT_SRC = 'https://accounts.google.com/gsi/client';
const GOOGLE_MAPS_SCRIPT_SRC = 'https://maps.googleapis.com/maps/api/js';
const GSI_SCRIPT_ID = 'gsi';

let mapsApi;
let autocompleteService;
let placesService;
let googleIdentity;

export const init = async () => {
  try {
    await loadScript(
      `${GOOGLE_MAPS_SCRIPT_SRC}?key=${process.env.REACT_APP_GOOGLE_API_KEY}&libraries=places&callback=Function.prototype`,
      GOOGLE_MAPS_SCRIPT_ID,
    );
    mapsApi = window.google.maps;
    autocompleteService = new window.google.maps.places.AutocompleteService();
    placesService = new window.google.maps.places.PlacesService(document.createElement('div'));

    await loadScript(GSI_SCRIPT_SRC, GSI_SCRIPT_ID);

    if (window.google && window.google.accounts) {
      googleIdentity = window.google.accounts.id;
    }
  } catch (error) {
    console.error('Error initializing Google Identity Services:', error);
  }
};

export const getApis = () => ({
  mapsApi,
  autocompleteService,
  placesService,
  googleIdentity,
});
